import './App.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {NextUIProvider} from "@nextui-org/system";
import {AuthProvider} from "./context/authContext";
import {HTML5Backend} from "react-dnd-html5-backend";
import {DndProvider} from "react-dnd";
import {AppProviders} from "./app/providers";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <DndProvider backend={HTML5Backend}>
    <NextUIProvider>
        <main className="dark text-foreground bg-background">
        <AppProviders>
            <AuthProvider>
                <App />
            </AuthProvider>
        </AppProviders>
        </main>
    </NextUIProvider>
    </DndProvider>
);
